import type { FunctionComponent } from 'react';
import { Link } from 'react-router-dom';

import { Button, Text } from '@kanda-libs/ks-design-library';
import { TickList, Title } from '@kanda-libs/ks-design-library-new';

import JobLayout from 'components/JobLayout';
import { URLS } from 'config';
import ApplyHeader from 'pages/StartApplication/components/ApplyHeader';
import ApplyProvider from 'pages/StartApplication/components/ApplyProvider';

import { CLASS_NAMES } from './constants';
import useWelcome from './useWelcome';

const Welcome: FunctionComponent = function () {
  const { id, jobTotalForMinimumMonthlyCost, monthlyCost, financeOption } =
    useWelcome();

  return (
    <ApplyProvider>
      <JobLayout
        header={<ApplyHeader title="Get pre-approved" showSubTitle={false} />}
      >
        <>
          <div className={CLASS_NAMES.title}>
            <Title>
              <>
                Get finance and pay as low as{' '}
                <span className={CLASS_NAMES.titleHighlight}>
                  <>{monthlyCost >= 0 && `£${monthlyCost / 100}`}</>
                </span>{' '}
                per month*
              </>
            </Title>
          </div>
          <TickList
            rows={[
              "Check if you're eligible for a loan in less than 60 seconds",
              "A soft credit check is performed that doesn't affect your credit score",
              'We will use this information to show you your most likely options for approval',
            ]}
          />
          <Text
            text={`* calculated assuming the amount borrowed is £${(
              jobTotalForMinimumMonthlyCost / 100
            ).toLocaleString()}, over ${
              financeOption?.duration || 0
            } months, at an interest rate of ${
              (financeOption?.apr || 0) / 100
            }% APR`}
            className={CLASS_NAMES.notice}
          />
          <Link to={URLS.applyDetails.replace(':id', id)}>
            <div className={CLASS_NAMES.button}>
              <Button.Text
                id="apply-welcome-get-finance"
                label="Get Finance"
                variant="gradient"
                icon="arrow-right"
                className={CLASS_NAMES.button}
              />
            </div>
          </Link>
          <Text
            text="Credit is subject to status.
          Representative example: 11.9% APR Representative based on a loan of
          £5000 repayable over 60 months at an interest rate of 11.9% pa
          (fixed). Monthly repayment of £109.45. Total amount payable £6567.16."
            className={CLASS_NAMES.notice}
          />
        </>
      </JobLayout>
    </ApplyProvider>
  );
};

export default Welcome;
